// Tiny helper for admin localStorage token + authenticated fetch
const TOKEN_KEY = "hs_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const API = process.env.REACT_APP_BACKEND_URL;

export const adminFetch = async (path, options = {}) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { ...options, headers });
  if (res.status === 401) {
    clearToken();
    // Let the caller decide what to do (e.g. redirect)
    const err = new Error("Unauthorized");
    err.status = 401;
    throw err;
  }
  return res;
};
